import { LOCAL_FORAGE_PENDING_UPLOAD_PROPERTY_TABLE_NAME } from "../../../localforage/LocalForageConstant";
import { LocalForageBackedFifoPropertyListManager } from "./LocalForageBackedFifoPropertyListManager";
import { PropertyListManager } from "./PropertyListManager";
import localforage from "localforage";

export class RecentlyCreatedPropertyListManagerFactory {
    private static readonly INSTANCE: LocalForageBackedFifoPropertyListManager = new LocalForageBackedFifoPropertyListManager(
        localforage.createInstance({name: LOCAL_FORAGE_PENDING_UPLOAD_PROPERTY_TABLE_NAME})
    );

    public static getInstance(): PropertyListManager {
        return this.INSTANCE;
    }
}